import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  updatePersonalDataApiService,
  type PersonalData,
  type UpdatePersonalDataRequest,
} from "@/generated/fastapi";

function formatErrorDetail(detail: unknown): string | null {
  if (!detail) return null;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((item) => formatErrorDetail(item))
      .filter(Boolean)
      .join(" ");
  }
  if (typeof detail === "object") {
    const value = detail as {
      msg?: unknown;
      message?: unknown;
      detail?: unknown;
    };
    return (
      formatErrorDetail(value.message) ??
      formatErrorDetail(value.msg) ??
      formatErrorDetail(value.detail) ??
      null
    );
  }
  return null;
}

export async function updatePersonalData(
  accessToken: string | null | undefined,
  request: UpdatePersonalDataRequest,
) : Promise<PersonalData> {
  const response = await updatePersonalDataApiService({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(
      formatErrorDetail(response.error) || "Failed to update personal data",
    );
  }

  return response.data;
}
